"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagPG = function FlagPG(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.4-120.29a7,7,0,0,0-2.6,5.35V139.3a7.07,7.07,0,0,0,7.06,7.06H209.54a7,7,0,0,0,4.46-1.71Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-151.8,7.61l-4,12.12-12.78.1a1.27,1.27,0,0,0-.74,2.3l10.27,7.58-3.85,12.18a1.28,1.28,0,0,0,2,1.43l10.39-7.43,10.39,7.43a1.28,1.28,0,0,0,2-1.43l-3.86-12.18,10.28-7.58a1.28,1.28,0,0,0-.75-2.3l-12.77-.1-4-12.12a1.27,1.27,0,0,0-2.41,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-64.77,7.61l-4,12.12-12.77.1a1.28,1.28,0,0,0-.75,2.3l10.28,7.58-3.85,12.18a1.27,1.27,0,0,0,2,1.43l10.39-7.43,10.4,7.43a1.28,1.28,0,0,0,2-1.43l-3.85-12.18,10.28-7.58a1.28,1.28,0,0,0-.75-2.3l-12.78-.1-4-12.12a1.27,1.27,0,0,0-2.41,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-108.29-45.14l-4,12.12-12.78.1a1.27,1.27,0,0,0-.74,2.3L-115.57-23l-3.86,12.17a1.28,1.28,0,0,0,2,1.43l10.39-7.43,10.39,7.43a1.28,1.28,0,0,0,2-1.43L-98.59-23l10.28-7.59a1.27,1.27,0,0,0-.75-2.3l-12.77-.1-4-12.12a1.28,1.28,0,0,0-2.42,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-108.29,84.58l-4,12.12-12.78.1a1.27,1.27,0,0,0-.74,2.3l10.28,7.59-3.86,12.17a1.28,1.28,0,0,0,2,1.43l10.39-7.43,10.39,7.43a1.28,1.28,0,0,0,2-1.43l-3.86-12.17,10.28-7.59a1.27,1.27,0,0,0-.75-2.3l-12.77-.1-4-12.12a1.28,1.28,0,0,0-2.42,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-88,53l-2.15,6.45-6.79,0a.68.68,0,0,0-.4,1.22l5.46,4-2,6.47a.68.68,0,0,0,1,.76L-87.38,68-81.85,72a.68.68,0,0,0,1-.76l-2-6.47,5.47-4a.68.68,0,0,0-.4-1.22l-6.79,0L-86.73,53A.68.68,0,0,0-88,53Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M157.05,6.05c-1-8-4.45-15.91-6.94-20.79,1.23.62,3.14,1.72,3.14,1.72l-1.68-6.1a24,24,0,0,1,7.36,4.94c-2.11-10.52-5.37-15.47-5.37-15.47l2.64.95c-4.95-12.2-12.32-15.68-12.32-15.68l4.21-1a33.65,33.65,0,0,0-14.94-10.41l5.68-2.74c-15-8.52-29.56.42-29.56.42s5-5.26,6.94-7.46-2.63-2.95-2.63-2.95,4.42-3.05,4.21-4.84-4.21-.84-4.21-.84,3.47-3.58,3.47-5.58-3.57-.74-3.57-.74A19.79,19.79,0,0,0,115-84.88c.32-1.89-3.16-.32-3.16-.32s3.9-6.94,3.69-8.41S105.27-88.88,98.12-82s-6.3,17.83-5.66,20.45,1,8.71-2.14,10.85-8.83-3.1-11.63-6.33-6.31-2.1-10-.84-10.52-.42-12.63-.7,2.38,2.1,6.17,3.5,5.48,4.77,10.8,6.74c4.68,1.72,8.41,6.09,4.74,8.1C75-38.7,75-41.22,62.34-44.48S34.57-15.65,34.57-15.65a20,20,0,0,0,12.25-5.86l-2.19,6.28A15.69,15.69,0,0,0,53.56-20L52-13.67c4.6-1.42,7.77-6.33,7.77-6.33l-1.35,6.25A17.28,17.28,0,0,0,65.28-20c.48,2.29.85,7,.85,7,7-3.74,8.63-9,8.63-9,8,24.2,19.57,28.2,19.57,28.2L95-.18a26.23,26.23,0,0,0,8.63,7.57l-.84-5.47c12.41,15.15,26.72,18.94,26.72,18.94l-3.67-8.39,4.51.92c-4.84-4.1-6.63-11.26-6.63-11.26l3.79.63a43.49,43.49,0,0,1-9.15-12L122-8.6c-1.16-1.79-2.11-8.1-2.11-8.1A35.87,35.87,0,0,1,130.1-12l.4-2.29c5.78,4.16,15.27,11.91,21.84,21.65A24.79,24.79,0,0,1,150.51,17c-6,14.71-21.88,13.75-28.9,10.66,0,0,21.75,17,33.67-7.15a19.52,19.52,0,0,0,1.57-4.85,32.87,32.87,0,0,1,2.71,11.09c1.26,24.62-24.41,22.3-24.41,22.3s28.41,11.37,29.67-21.46c.28-7.3-2.81-14.59-7.77-21.54ZM131.24-18.52l.12-.71a37.56,37.56,0,0,1,8.84,4.32l1-3a51.42,51.42,0,0,1,9.58,16.36,139.52,139.52,0,0,0-19.54-17Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagPG;
exports["default"] = _default;